"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LinksGeneralHandler", {
    enumerable: true,
    get: function() {
        return LinksGeneralHandler;
    }
});
const _rollupgeneralhandler = require("../rollup/rollup.general.handler");
const _generic = require("~/db/field-handler/handlers/generic");
let LinksGeneralHandler = class LinksGeneralHandler extends _generic.GenericFieldHandler {
    async filter(knex, filter, column, options) {
        return new _rollupgeneralhandler.RollupGeneralHandler().filter(knex, filter, column, options);
    }
};
